import { firestore } from '../plugins/firebase'
import {
  buildCampaignInvitationPath,
  buildCampaignInvitationUrl,
  parseUserInvitationFields,
  resolveInvitationBaseUrl,
  waitForInvitationUrlWithFetcher
} from './invitation-link.core'

export {
  buildCampaignInvitationPath,
  buildCampaignInvitationUrl,
  resolveInvitationBaseUrl
}

/**
 * Reads invitation-related fields from the user document.
 * @param {string} userId
 * @param {FirebaseFirestore.Firestore} [db]
 * @returns {Promise<{ invitationKind: 'new'|'existing'|'unknown', userToken: string|null }>}
 */
export async function fetchUserInvitationFields (userId, db) {
  const firestoreDb = db || await firestore
  const userDoc = await firestoreDb.collection('app/v1/users').doc(userId).get()
  const data = userDoc.exists ? (userDoc.data() || {}) : {}
  return parseUserInvitationFields({
    exists: userDoc.exists,
    data
  })
}

/**
 * Polls Firestore until invitation URL fields are definitive.
 * @param {string} userId
 * @param {{ maxAttempts?: number, intervalMs?: number, baseUrl?: string, expectNewUser?: boolean, db?: Object, sleep?: (ms: number) => Promise<void> }} [options]
 * @returns {Promise<{ url: string|null, isNewUser: boolean, userToken: string|null, ready: boolean }>}
 */
export async function waitForInvitationUrl (userId, options = {}) {
  const db = options.db != null ? options.db : await firestore
  const fetchFields = () => fetchUserInvitationFields(userId, db)
  return waitForInvitationUrlWithFetcher(fetchFields, options)
}

/**
 * Copies text to the clipboard with a textarea fallback.
 * @param {string} text
 * @returns {Promise<void>}
 */
export async function copyTextToClipboard (text) {
  if (typeof navigator !== 'undefined' && navigator.clipboard && navigator.clipboard.writeText) {
    await navigator.clipboard.writeText(text)
    return
  }
  const textarea = document.createElement('textarea')
  textarea.value = text
  textarea.setAttribute('readonly', '')
  textarea.style.position = 'fixed'
  textarea.style.left = '-9999px'
  document.body.appendChild(textarea)
  textarea.select()
  const succeeded = document.execCommand('copy')
  document.body.removeChild(textarea)
  if (!succeeded) {
    throw new Error('Clipboard copy failed')
  }
}



// WEBPACK FOOTER //
// ./src/lib/invitation-link.js